<template>

</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "VersionChecker",
        data: () => ({
            checkInterval: null
        }),
        computed: {
            ...mapGetters([
                'manifest',
            ]),
        },
        methods: {
            updateManifest() {
                this.$store.dispatch('updateManifest');
            },
            updateManifestTimer() {
                this.updateManifest();
            }
        },
        watch: {
            manifest(prev_val, val) {
                if (prev_val && val && (JSON.stringify(prev_val) !== JSON.stringify(val))) {
                    window.location.reload(true);
                }
            }
        },
        mounted() {
            this.updateManifest();
            this.checkInterval = setInterval(this.updateManifestTimer, 300000)
        }
    }
</script>

<style scoped>

</style>